import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { CloseOutlined } from '@ant-design/icons';
import { setLocalStorageData } from '../../commonFunction';
import { setAdsState } from '../../../features/sharingAdvertisment/SharingAdSlice';
import appStore from "../../../assets/icons/App Store.svg";
import googlePlay from "../../../assets/icons/Google Play.svg";
import mobile from '../../../assets/icons/mobile.png';
import './MobileAppAlert.scss';

const MobileAppAlert = memo(function MobileAppAlert() {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();

    const handleCloseIcon = useCallback(() => {
        // setLocalStorageData("ads", false);
        dispatch(setAdsState(false));
    }, [dispatch]);

    const APP_LINKS = [
        {
            url: "https://apps.apple.com/in/app/fanzaty/id6746043884",
            icon: appStore,
            alt: "App Store"
        },
        {
            url: "https://play.google.com/store/apps/details?id=com.fanzaty.app",
            icon: googlePlay,
            alt: "Google Play"
        }
    ];

    return (
        <div className='alert'>
            <div className="container">
                <div className="content">
                    <h4 className="sharing-heading">{t("sharing.heading")}</h4>
                    <span className="sub-sharing-heading">{t("sharing.sub_heading")}</span>
                    <img className="alert-mobile" src={mobile} alt="phone" loading="lazy" />
                    <b className="sharing-download">{t("sharing.download")}</b>
                    <div className="alert-icons">
                        {APP_LINKS.map(({ url, icon, alt }) => (
                            <a
                                key={url}
                                href={url}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                <img className='apple-icon' alt={alt} src={icon} loading="lazy" />
                            </a>
                        ))}
                        <div className='close-icon' onClick={handleCloseIcon} aria-label="Close alert">
                            <CloseOutlined />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

MobileAppAlert.displayName = 'MobileAppAlert';

export default MobileAppAlert;
